export default {
  metadata: {
    version: '1.0.0',
    id: 'badge-1.0.0',
    name: 'JDSBadge',
    description:
      'A Badge is used to draw attention to new or categorized content elements.',
    usage:
      'Badges are not interactive. They are only used to describe a category or feature of the content they associate with.'
  },
  hierarchy: {
    container: ['icon', 'text']
  },
  base: {
    container: {
      hidden: false,
      'flex-direction': '{b_0}',
      'justify-content': '{b_1}',
      'align-items': '{b_2}',
      'padding-top': '{b_3}',
      'padding-left': '{b_4}',
      'padding-right': '{b_5}',
      'padding-bottom': '{b_6}',
      gap: '{b_7}',
      'background-color': '{b_8}',
      'border-radius': '{b_9}'
    },
    icon: {
      hidden: false,
      size: '{b_10}',
      color: '{b_11}',
      'justify-content': '{b_12}',
      'align-items': '{b_13}'
    },
    text: {
      hidden: false,
      'font-family': '{b_14}',
      'font-size': '{b_15}',
      'line-height': '{b_16}',
      'letter-spacing': '{b_17}',
      'font-weight': '{b_18}',
      color: '{b_19}',
      'max-lines': 1,
      'text-transform': '{b_20}'
    }
  },
  variant: {
    kind: {
      service: {
        container: {
          'border-radius': '{b_21}',
          'background-color': '{b_22}',
          'padding-top': '{b_23}',
          'padding-left': '{b_24}',
          'padding-right': '{b_25}',
          'padding-bottom': '{b_26}',
          gap: '{b_27}'
        },
        text: {
          'font-family': '{b_28}',
          'font-size': '{b_29}',
          'line-height': '{b_30}',
          'letter-spacing': '{b_31}',
          'font-weight': '{b_32}',
          color: '{b_33}',
          'text-transform': '{badge_variant_kind_service_text_text-transform}'
        },
        icon: {
          size: '{b_34}',
          color: '{b_35}'
        }
      }
    },
    _hasIcon: {
      false: {
        icon: {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      normal: {
        small: {
          container: {
            'border-radius': '{b_36}'
          },
          icon: {
            size: '{b_37}'
          },
          text: {
            'font-family': '{b_38}',
            'font-size': '{b_39}',
            'line-height': '{b_40}',
            'letter-spacing': '{b_41}',
            'font-weight': '{b_42}'
          }
        },
        large: {
          container: {
            'padding-left': '{b_43}',
            'padding-right': '{b_44}',
            gap: '{b_45}'
          },
          icon: {
            size: '{b_46}'
          },
          text: {
            'font-family': '{b_47}',
            'font-size': '{b_48}',
            'line-height': '{b_49}',
            'letter-spacing': '{b_50}',
            'font-weight': '{b_51}'
          }
        }
      }
    },
    {
      service: {
        false: {
          container: {
            'padding-left': '{b_25}',
            'padding-right': '{b_25}'
          }
        }
      }
    }
  ],
  combination_config: [
    ['kind', 'size'],
    ['kind', '_hasIcon']
  ],
  api: {
    data: {
      text: {
        value: {
          type: 'string',
          name: 'label',
          doc_description: 'It is used to display label of badge.'
        }
      },
      icon: {
        value: {
          type: 'icon',
          name: 'icon',
          doc_description: 'It displays icon on the left with text.'
        }
      }
    },
    config: {
      kind: {
        values: ['normal', 'service'],
        doc_description: 'It can be used to switch between 2 variants of Badge.'
      },
      size: {
        values: ['medium', 'small', 'large'],
        doc_description: 'It can be used to adjust the size of Badge.'
      },
      _hasIcon: {
        values: [true, false]
      }
    },
    a11y: {
      container: {
        properties: {
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
